import http from "./http_common";

class CommonService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  CitiesList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`cityMaster/list/filter?${queryString}`);
  }
  
  StatesList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/stateMaster/list/filter?${queryString}`);
  }

  CountriesList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/country_Master/list/filter?${queryString}`);
  }

  languagesList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/languageMaster/list/filter?${queryString}`);
  }

  relationList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/RelationMaster/list/filter?${queryString}`);
  }

  ServiceCategory(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/serviceCategory/list/filter?${queryString}`);
  }
  ServiceController(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/services/list/filter?${queryString}`);
  }
  PatientServices(data) {
    return http.post(`/patientServices/save`, data);
  }
  PatientServiceslist(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/patientServices/list/filter?${queryString}`);
  }

  demoRequestsList(payload){
    const queryString = this.queryString(payload);
    return http.get(`/DemoEnquiry/list/filter?${queryString}`);
  }

  qualificationsList(payload){
    const queryString = this.queryString(payload);
    return http.get(`/QualificationMaster/list/filter?${queryString}`);
  }
}

export default new CommonService();
